import { useFormik } from "formik";
import { useEffect } from "react";
import * as Yup from "yup";
import { useUserInfo } from "../context/UserInfoContext";
import EN from "../locales/en";
import Button from "./Button";
import Input from "./Input";
import ErrorIcon from "./icons/ErrorIcon";

const validationSchema = Yup.object({
  postcode: Yup.string().required(EN.address.postcode_empty_text),
});

const AddressLookupForm = () => {
  const {
    postcode,
    setPostcode,
    fetchingAddressResults,
    isEditingPostcode,
    setIsEditingPostcode,
    lookupAddress,
    postcodeError,
  } = useUserInfo();

  const formik = useFormik({
    initialValues: {
      postcode: postcode || "",
    },
    validationSchema,
    onSubmit: async (values) => {
      await lookupAddress(values.postcode);
    },
  });

  const handleChangePostcodeText = () => {
    setIsEditingPostcode(true);
  };

  useEffect(() => {
    setPostcode(formik.values.postcode.replaceAll(/\s+/g, ""));
  }, [formik.values.postcode]);

  return (
    <div className="w-full max-w-lg">
      {isEditingPostcode ? (
        <form onSubmit={formik.handleSubmit}>
          <Input
            id="postcode"
            name="postcode"
            labelText={EN.address.postcode_label_text}
            placeholder={EN.address.postcode_input_placeholder}
            value={formik.values.postcode}
            onChange={(e) => {
              e.target.value = e.target.value.toUpperCase();
              formik.handleChange(e);
            }}
            disabled={fetchingAddressResults}
            hasErrors={formik.errors.postcode || postcodeError}
          />

          {(formik.errors.postcode || postcodeError) && (
            <div className="mt-3 flex justify-start items-start">
              <ErrorIcon />
              <p className="flex-1 text-red-500 text-sm">
                {formik.errors.postcode
                  ? formik.errors.postcode
                  : EN.address.postcode_error_text}
              </p>
            </div>
          )}

          <div className="mt-8">
            <Button
              type="submit"
              disabled={formik.errors.postcode || fetchingAddressResults}
              fullWidth
            >
              {fetchingAddressResults
                ? EN.address.button_loading_text
                : EN.address.button_text}
            </Button>
          </div>
        </form>
      ) : (
        <div>
          <span className="block text-md font-bold leading-[1.5] mb-1">
            {EN.address.postcode_label_text}
          </span>
          <p className="text-lg">
            {postcode}{" "}
            <button
              onClick={handleChangePostcodeText}
              className="text-primary underline"
            >
              {EN.address.change_button_text}
            </button>
          </p>
        </div>
      )}
    </div>
  );
};

export default AddressLookupForm;
